export function initAgeGate() {
  const gate = document.getElementById('ageGate');
  if (!gate) return;

  // If already verified (cookie), remove gate immediately
  if (document.cookie.includes('age_verified=1')) {
    gate.remove();
    return;
  }

  // Remove all page content except the age gate
  const siteContent = [];
  Array.from(document.body.children).forEach((child) => {
    if (child !== gate && !child.matches('script, link, style, noscript')) {
      siteContent.push(child);
      child.remove();
    }
  });

  const input = document.getElementById('ageGateDate');
  const submitBtn = document.getElementById('ageGateSubmit');
  const rememberCheckbox = document.getElementById('ageGateRemember');

  // Error message element (shown under the submit button)
  const errorEl = document.createElement('div');
  errorEl.className = 'age-gate__error';
  errorEl.style.display = 'none';
  errorEl.setAttribute('aria-live', 'polite');
  // insert error element after submit button
  if (submitBtn && submitBtn.parentNode) {
    submitBtn.parentNode.insertBefore(errorEl, submitBtn.nextSibling);
  }

  // Auto-format input as DD / MM / YYYY
  input.addEventListener('input', (e) => {
    let value = e.target.value.replace(/[^0-9]/g, '');

    if (value.length > 8) {
      value = value.slice(0, 8);
    }

    let formatted = '';
    for (let i = 0; i < value.length; i++) {
      if (i === 2 || i === 4) {
        formatted += ' / ';
      }
      formatted += value[i];
    }

    e.target.value = formatted;
  });

  // Handle paste
  input.addEventListener('paste', (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    const digits = pasted.replace(/[^0-9]/g, '').slice(0, 8);
    let formatted = '';
    for (let i = 0; i < digits.length; i++) {
      if (i === 2 || i === 4) formatted += ' / ';
      formatted += digits[i];
    }
    input.value = formatted;
    // clear any previous error while pasting
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  });

  function parseDate(str) {
    const digits = str.replace(/[^0-9]/g, '');
    if (digits.length !== 8) return null;

    const day = parseInt(digits.slice(0, 2), 10);
    const month = parseInt(digits.slice(2, 4), 10);
    const year = parseInt(digits.slice(4, 8), 10);

    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) return null;

    const date = new Date(year, month - 1, day);
    // Verify the date is valid (e.g. not Feb 30)
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return null;
    }

    return date;
  }

  function isOfLegalAge(birthDate) {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age >= 18;
  }

  function finishSuccess() {
    window.location.reload();
  }

  function verify() {
    const birthDate = parseDate(input.value);

    if (!birthDate) {
      input.classList.add('age-gate__input--error');
      if (errorEl) {
        errorEl.textContent = 'Invalid date format.';
        errorEl.style.display = 'block';
      }
      return;
    }

    input.classList.remove('age-gate__input--error');

    if (!isOfLegalAge(birthDate)) {
      input.classList.add('age-gate__input--error');
      if (errorEl) {
        errorEl.textContent = 'You must be over 18 years of age to enter this website.';
        errorEl.style.display = 'block';
      }
      return;
    }

    // Set cookie
    if (rememberCheckbox.checked) {
      const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `age_verified=1; expires=${expires}; path=/; SameSite=Lax`;
    } else {
      document.cookie = 'age_verified=1; path=/; SameSite=Lax';
    }

    // clear error and hide gate with transition, then reload the page
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
    gate.classList.add('age-gate--hidden');

    gate.addEventListener('transitionend', finishSuccess, { once: true });
    window.setTimeout(finishSuccess, 600);
  }

  submitBtn.addEventListener('click', verify);

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') verify();
  });
}
